import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const TorihikisakiKbn = props => {
  return <Dropdown.Static kubunKey='torihikisaki_kbn' {...props} />
}
